import React from 'react'
import { ArrayInput, SimpleFormIterator, Validator } from 'react-admin'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import DayMonthInput from 'ui-shared/WrappedInputs/DayMonthInput'
import HalfStepNumberInput from 'ui-shared/WrappedInputs/HalfStepNumberInput'
import { PricingRuleSet } from 'services/api/entities/catalog/types'
import WeekDaysRangeInput from './WeekDaysRangeInput'

export type PricingByRulesInputProps = {
  source?: string
  validatePricingRules?: Validator[]
  children: JSX.Element | JSX.Element[]
  defaultValue?: Partial<PricingRuleSet>[]
}

const PricingByRulesInput: React.FC<PricingByRulesInputProps> = ({
  source = 'pricing',
  children,
  defaultValue,
}) => {
  return (
    <ArrayInput source={source} label="" fullWidth defaultValue={defaultValue}>
      <SimpleFormIterator>
        <DayMonthInput
          source="periodFrom"
          label="form.fields.periodFrom"
          style={{ marginBottom: '16px' }}
        />
        <DayMonthInput
          source="periodTo"
          label="form.fields.periodTo"
          style={{ marginBottom: '32px' }}
        />
        <WeekDaysRangeInput />
        <HalfStepNumberInput source="minHours" label="form.fields.minHours" />
        <Kdivider />
        {children}
      </SimpleFormIterator>
    </ArrayInput>
  )
}

export default PricingByRulesInput
